export default "__VITE_PUBLIC_ASSET__85450053__"